import React, { useState } from 'react';
import { Globe, Bell, Shield, CreditCard, Mail, Server, Key, Database, Smartphone, CheckCircle2, Save, Plus, Trash2, Edit2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminSettingsFullManagerProps {
  success: (msg: string) => void;
}
export function AdminSettingsFullManager({
  success
}: AdminSettingsFullManagerProps) {
  const [notifSettings, setNotifSettings] = useState<Record<string, boolean>>({
    newOrders: true,
    newAstrologers: true,
    pushNotifications: false,
    weeklyDigest: true,
    systemErrors: true,
    paymentFailures: true
  });
  const [paymentSystems, setPaymentSystems] = useState([{
    name: 'Stripe',
    status: true,
    fee: '2.9% + 30¢'
  }, {
    name: 'PayPal',
    status: true,
    fee: '3.49% + 49¢'
  }, {
    name: 'CloudPayments',
    status: false,
    fee: '2.8%'
  }, {
    name: 'Crypto (USDT)',
    status: true,
    fee: '1%'
  }]);
  const [services, setServices] = useState([{
    id: 'SRV-001',
    name: 'Натальная карта (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 490 ₽',
    status: 'active'
  }, {
    id: 'SRV-002',
    name: 'Соляр на год (AI)',
    category: 'AI Отчёты',
    type: 'Автоматическая',
    price: '1 990 ₽',
    status: 'active'
  }, {
    id: 'SRV-003',
    name: 'Консультация (30 мин)',
    category: 'Консультации',
    type: 'Видео',
    price: 'от 3 000 ₽',
    status: 'active'
  }, {
    id: 'SRV-004',
    name: 'Базовый курс астрологии',
    category: 'Курсы',
    type: 'Видеокурс',
    price: '15 000 ₽',
    status: 'active'
  }]);
  const handleSave = () => {
    success('Настройки успешно сохранены');
  };
  const renderToggle = (label: string, checked: boolean, onChange: () => void, description?: string) => <div className="flex items-start justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6535">
      <div data-id="element-6536">
        <div className="text-sm font-medium text-slate-900" data-id="element-6537">{label}</div>
        {description && <div className="text-xs text-slate-500 mt-0.5" data-id="element-6538">{description}</div>}
      </div>
      <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ml-4 ${checked ? 'bg-indigo-500' : 'bg-slate-300'}`} onClick={onChange} data-id="element-6539">
        <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6540" />
      </button>
    </div>;
  const generalSettings = <div className="space-y-6 max-w-3xl" data-id="element-6541">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6542">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6543">
          <Globe className="w-4 h-4 text-indigo-500" data-id="element-6544" /> Основная информация
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6545">
          <Input label="Название платформы" defaultValue="Astriqo" data-id="element-6546" />
          <Input label="Основной домен" defaultValue="astriqo.com" data-id="element-6547" />
          <Input label="Email поддержки" defaultValue="support@astriqo.com" data-id="element-6548" />
          <Input label="Телефон поддержки" defaultValue="+7 (800) 555-35-35" data-id="element-6549" />
          <div className="md:col-span-2" data-id="element-6550">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6551">
              Язык по умолчанию
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6552">
              <option value="ru" data-id="element-6553">Русский (RU)</option>
              <option value="en" data-id="element-6554">English (EN)</option>
              <option value="es" data-id="element-6555">Español (ES)</option>
            </select>
          </div>
        </div>
      </Card>

      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6556">
        <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6557">
          <Database className="w-4 h-4 text-indigo-500" data-id="element-6558" /> Локализация и форматы
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-6559">
          <div data-id="element-6560">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6561">
              Основная валюта
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6562">
              <option value="RUB" data-id="element-6563">Российский рубль (₽)</option>
              <option value="USD" data-id="element-6564">Доллар США ($)</option>
              <option value="EUR" data-id="element-6565">Евро (€)</option>
            </select>
          </div>
          <div data-id="element-6566">
            <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6567">
              Часовой пояс сервера
            </label>
            <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6568">
              <option value="Europe/Moscow" data-id="element-6569">Europe/Moscow (UTC+3)</option>
              <option value="UTC" data-id="element-6570">UTC</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex justify-end" data-id="element-6571">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6573" />} onClick={handleSave} data-id="element-6572">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const servicesSettings = <div className="space-y-6" data-id="element-6574">
      <div className="flex justify-between items-center" data-id="element-6575">
        <h3 className="text-sm font-bold text-slate-900" data-id="element-6576">
          Управление услугами
        </h3>
        <Button variant="primary" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6578" />} data-id="element-6577">
          Добавить услугу
        </Button>
      </div>

      <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-6579">
        <table className="w-full text-left" data-id="element-6580">
          <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-6581">
            <tr data-id="element-6582">
              <th className="px-4 py-3 font-medium" data-id="element-6583">ID</th>
              <th className="px-4 py-3 font-medium" data-id="element-6584">Название</th>
              <th className="px-4 py-3 font-medium" data-id="element-6585">Категория</th>
              <th className="px-4 py-3 font-medium" data-id="element-6586">Тип</th>
              <th className="px-4 py-3 font-medium" data-id="element-6587">Базовая цена</th>
              <th className="px-4 py-3 font-medium" data-id="element-6588">Статус</th>
              <th className="px-4 py-3 text-right font-medium" data-id="element-6589">Действия</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-6590">
            {services.map(s => <tr key={s.id} className="hover:bg-slate-50" data-id="element-6591">
                <td className="px-4 py-3 text-xs text-slate-500" data-id="element-6592">{s.id}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-900" data-id="element-6593">
                  {s.name}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6594">
                  {s.category}
                </td>
                <td className="px-4 py-3 text-xs text-slate-600" data-id="element-6595">{s.type}</td>
                <td className="px-4 py-3 text-sm font-bold text-slate-900" data-id="element-6596">
                  {s.price}
                </td>
                <td className="px-4 py-3" data-id="element-6597">
                  <Badge variant={s.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-6598">
                    {s.status === 'active' ? 'Активна' : 'Скрыта'}
                  </Badge>
                </td>
                <td className="px-4 py-3 text-right" data-id="element-6599">
                  <div className="flex justify-end gap-2" data-id="element-6600">
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Edit2 className="w-4 h-4 text-slate-400" data-id="element-6602" />} data-id="element-6601" />
                    <Button variant="ghost" size="sm" className="w-8 h-8 p-0" icon={<Trash2 className="w-4 h-4 text-rose-400" data-id="element-6604" />} data-id="element-6603" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Card>
    </div>;
  const paymentSettings = <div className="space-y-6 max-w-4xl" data-id="element-6605">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6606">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6607">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6608">
            <CreditCard className="w-4 h-4 text-indigo-500" data-id="element-6609" /> Платёжные шлюзы
          </h3>
          <div className="space-y-1" data-id="element-6610">
            {paymentSystems.map((p, i) => <div key={i} className="flex items-center justify-between py-3 border-b border-slate-100 last:border-0" data-id="element-6611">
                <div data-id="element-6612">
                  <div className="text-sm font-medium text-slate-900" data-id="element-6613">
                    {p.name}
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-6614">
                    Комиссия: {p.fee}
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-6615">
                  <Button variant="ghost" size="sm" className="text-xs h-7" data-id="element-6616">
                    Настроить
                  </Button>
                  <button className={`w-10 h-6 rounded-full transition-colors relative flex-shrink-0 ${p.status ? 'bg-emerald-500' : 'bg-slate-300'}`} onClick={() => {
                const newSystems = [...paymentSystems];
                newSystems[i].status = !newSystems[i].status;
                setPaymentSystems(newSystems);
                success(newSystems[i].status ? `${p.name} включен` : `${p.name} отключен`);
              }} data-id="element-6617">
                    <div className={`w-4 h-4 rounded-full bg-white absolute top-1 transition-transform ${p.status ? 'translate-x-5' : 'translate-x-1'}`} data-id="element-6618" />
                  </button>
                </div>
              </div>)}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6619">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6620">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6621" /> Финансовые настройки
          </h3>
          <div className="space-y-4" data-id="element-6622">
            <Input label="Базовая комиссия платформы (%)" defaultValue="20" data-id="element-6623" />
            <Input label="Минимальная сумма вывода (₽)" defaultValue="5000" data-id="element-6624" />
            <Input label="Период холда средств (дней)" defaultValue="14" data-id="element-6625" />

            <div className="pt-4 border-t border-slate-100" data-id="element-6626">
              {renderToggle('Автоматические выплаты', false, () => {}, 'Выплаты астрологам 1 и 15 числа месяца')}
              {renderToggle('Разрешить возвраты клиентам', true, () => {}, 'В течение 24 часов после оплаты')}
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6627">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6629" />} onClick={handleSave} data-id="element-6628">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const emailSettings = <div className="space-y-6 max-w-4xl" data-id="element-6630">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6631">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6632">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6633">
            <Mail className="w-4 h-4 text-indigo-500" data-id="element-6634" /> SMTP Настройки
          </h3>
          <div className="space-y-4" data-id="element-6635">
            <Input label="SMTP Сервер" defaultValue="smtp.sendgrid.net" data-id="element-6636" />
            <div className="grid grid-cols-2 gap-4" data-id="element-6637">
              <Input label="Порт" defaultValue="587" data-id="element-6638" />
              <div data-id="element-6639">
                <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6640">
                  Шифрование
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500" data-id="element-6641">
                  <option value="tls" data-id="element-6642">TLS</option>
                  <option value="ssl" data-id="element-6643">SSL</option>
                  <option value="none" data-id="element-6644">Нет</option>
                </select>
              </div>
            </div>
            <Input label="SMTP Логин" defaultValue="apikey" data-id="element-6645" />
            <Input label="SMTP Пароль" type="password" defaultValue="****************" data-id="element-6646" />
            <Input label="Отправитель (From Email)" defaultValue="noreply@astriqo.com" data-id="element-6647" />
            <Input label="Имя отправителя (From Name)" defaultValue="Astriqo" data-id="element-6648" />
            <Button variant="outline" size="sm" className="w-full mt-2" data-id="element-6649">
              Отправить тестовое письмо
            </Button>
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6650">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6651">
            <Bell className="w-4 h-4 text-indigo-500" data-id="element-6652" /> Системные уведомления
          </h3>
          <div className="space-y-1" data-id="element-6653">
            {renderToggle('Уведомления о новых заказах', notifSettings.newOrders, () => setNotifSettings(p => ({
            ...p,
            newOrders: !p.newOrders
          })))}
            {renderToggle('Заявки на верификацию', notifSettings.newAstrologers, () => setNotifSettings(p => ({
            ...p,
            newAstrologers: !p.newAstrologers
          })))}
            {renderToggle('Ошибки системы (Критичные)', notifSettings.systemErrors, () => setNotifSettings(p => ({
            ...p,
            systemErrors: !p.systemErrors
          })))}
            {renderToggle('Ошибки платежей', notifSettings.paymentFailures, () => setNotifSettings(p => ({
            ...p,
            paymentFailures: !p.paymentFailures
          })))}
            {renderToggle('Еженедельный дайджест', notifSettings.weeklyDigest, () => setNotifSettings(p => ({
            ...p,
            weeklyDigest: !p.weeklyDigest
          })))}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6654">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6656" />} onClick={handleSave} data-id="element-6655">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const securitySettings = <div className="space-y-6 max-w-4xl" data-id="element-6657">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-6658">
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6659">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6660">
            <Shield className="w-4 h-4 text-indigo-500" data-id="element-6661" /> Политики безопасности
          </h3>
          <div className="space-y-1" data-id="element-6662">
            {renderToggle('Двухфакторная авторизация (2FA)', true, () => {}, 'Обязательно для всех администраторов')}
            {renderToggle('Логирование всех входов', true, () => {}, 'Сохранять IP и User-Agent')}
            {renderToggle('Защита от брутфорса', true, () => {}, 'Блокировка после 5 неудачных попыток')}
            {renderToggle('Принудительная смена пароля', false, () => {}, 'Каждые 90 дней')}
            {renderToggle('Ограничение сессий', true, () => {}, 'Не более 3 активных сессий на пользователя')}
          </div>
        </Card>

        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6663">
          <h3 className="text-sm font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-6664">
            <Key className="w-4 h-4 text-indigo-500" data-id="element-6665" /> Ограничения доступа (IP)
          </h3>
          <div className="space-y-4" data-id="element-6666">
            <div data-id="element-6667">
              <label className="block text-xs font-medium text-slate-700 mb-1" data-id="element-6668">
                Белый список IP для админки
              </label>
              <textarea className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-500 min-h-[100px]" placeholder="Введите IP адреса по одному в строке..." defaultValue="192.168.1.1&#10;10.0.0.0/24" data-id="element-6669" />
              <p className="text-[10px] text-slate-500 mt-1" data-id="element-6670">
                Оставьте пустым для доступа с любого IP
              </p>
            </div>
            {renderToggle('Блокировать Tor/VPN', false, () => {})}
          </div>
        </Card>
      </div>

      <div className="flex justify-end" data-id="element-6671">
        <Button variant="primary" icon={<Save className="w-4 h-4" data-id="element-6673" />} onClick={handleSave} data-id="element-6672">
          Сохранить изменения
        </Button>
      </div>
    </div>;
  const apiSettings = <div className="space-y-6 max-w-4xl" data-id="element-6674">
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-6675">
        <div className="flex justify-between items-center mb-4" data-id="element-6676">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-6677">
            <Server className="w-4 h-4 text-indigo-500" data-id="element-6678" /> API Ключи
          </h3>
          <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-6680" />} data-id="element-6679">
            Создать ключ
          </Button>
        </div>

        <div className="space-y-4" data-id="element-6681">
          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6682">
            <div className="flex justify-between items-start mb-2" data-id="element-6683">
              <div data-id="element-6684">
                <div className="text-sm font-bold text-slate-900" data-id="element-6685">
                  Mobile App API (Production)
                </div>
                <div className="text-xs text-slate-500" data-id="element-6686">
                  Создан: 12.05.2023 • Последнее использование: 5 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6687">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6688">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6689">
                sk_live_51Mxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6690">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6691">
                <Trash2 className="w-4 h-4" data-id="element-6692" />
              </Button>
            </div>
          </div>

          <div className="p-4 border border-slate-200 rounded-lg bg-slate-50" data-id="element-6693">
            <div className="flex justify-between items-start mb-2" data-id="element-6694">
              <div data-id="element-6695">
                <div className="text-sm font-bold text-slate-900" data-id="element-6696">
                  OpenAI Integration Key
                </div>
                <div className="text-xs text-slate-500" data-id="element-6697">
                  Создан: 01.08.2023 • Последнее использование: 1 мин назад
                </div>
              </div>
              <Badge variant="success" size="sm" data-id="element-6698">
                Активен
              </Badge>
            </div>
            <div className="flex items-center gap-2 mt-3" data-id="element-6699">
              <code className="flex-1 px-3 py-2 bg-white border border-slate-200 rounded text-xs text-slate-600 font-mono" data-id="element-6700">
                sk-proj-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
              </code>
              <Button variant="outline" size="sm" className="h-8 px-3" data-id="element-6701">
                Копировать
              </Button>
              <Button variant="ghost" size="sm" className="h-8 px-2 text-rose-500 hover:bg-rose-50" data-id="element-6702">
                <Trash2 className="w-4 h-4" data-id="element-6703" />
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
  return <div className="space-y-6" data-id="element-6704">
      <div data-id="element-6705">
        <h2 className="text-xl font-bold text-slate-900" data-id="element-6706">
          Настройки платформы
        </h2>
        <p className="text-sm text-slate-500" data-id="element-6707">
          Глобальные параметры работы системы
        </p>
      </div>

      <Tabs tabs={[{
      id: 'general',
      label: 'Общие',
      content: generalSettings
    }, {
      id: 'services',
      label: 'Услуги',
      content: servicesSettings
    }, {
      id: 'payments',
      label: 'Платежи',
      content: paymentSettings
    }, {
      id: 'email',
      label: 'Email',
      content: emailSettings
    }, {
      id: 'security',
      label: 'Безопасность',
      content: securitySettings
    }, {
      id: 'api',
      label: 'API',
      content: apiSettings
    }]} data-id="element-6708" />
    </div>;
}